import { useTranslation } from 'react-i18next'
import { EditSolidIcon } from '@dhl-ui/icons'
import { Body1, Body2, Box, Card, Grid, H6, IconButton } from '@dhl-ui/components'
import { getUserTypeLabel, type User } from '~/modules/users/model'

type Props = {
  user: User
  onEditClick: () => void
}

export const ProfileCard = ({ user, onEditClick }: Props) => {
  const { t } = useTranslation()
  const { email, userType, name, id: userId } = user

  return (
    <Card>
      <Card.Header
        title={t('admin.usersPage.profileView.titleText')}
        endNode={
          <IconButton aria-label="edit user details" onClick={onEditClick}>
            <EditSolidIcon data-testid="edit-user-details" />
          </IconButton>
        }
      />
      <Card.Content>
        <Grid container direction="column" justifyContent="center" alignItems="stretch" size={{ xs: 12 }}>
          <Grid size={{ xs: 12 }}>
            <H6>{t('admin.usersPage.profileView.accountText')}</H6>
          </Grid>
          <Grid size={{ xs: 12 }}>
            <Box marginTop={1}>
              <Body2 variant="tertiary">{t('admin.usersPage.profileView.userId')}</Body2>
              <Body1 data-testid="user-userId">{String(userId)}</Body1>
            </Box>
          </Grid>
          <Grid size={{ xs: 12 }}>
            <Box marginTop={1}>
              <Body2 variant="tertiary">{t('admin.usersPage.profileView.userType')}</Body2>
              <Body1 data-testid="user-userType">{getUserTypeLabel(userType)}</Body1>
            </Box>
          </Grid>
          <Grid container direction="row" justifyContent="center" alignItems="stretch" size={{ xs: 12 }}>
            <Grid size={{ xs: 12 }} sx={{ marginTop: 1 }}>
              <Body2 variant="tertiary">{t('admin.usersPage.profileView.name')}</Body2>
              <Body1 data-testid="user-firstName">{name.firstName}</Body1>
            </Grid>
            <Grid size={{ xs: 12 }} sx={{ marginTop: 1 }}>
              <Body2 variant="tertiary">{t('admin.usersPage.profileView.surname')}</Body2>
              <Body1 data-testid="user-lastName">{name.lastName}</Body1>
            </Grid>
          </Grid>
          <Grid size={{ xs: 12 }} sx={{ marginTop: 1 }}>
            <Body2 variant="tertiary">{t('admin.usersPage.profileView.emailAddress')}</Body2>
            <Body1 data-testid="user-email">{email}</Body1>
          </Grid>
        </Grid>
      </Card.Content>
    </Card>
  )
}
